module.exports = __webpack_public_path__ + "be46ebbb084356451a0464f8e77bcffd.pdf";